import styled from "styled-components";
import { Typography } from "../atoms/Typography";
import { MenuItem } from "../atoms/MenuItem";

/**
 * [共通パーツ]メニューリスト
 */

type MenuListProps = {
  onCreatePrescriptionClick: () => void;
  isAdminMenuVisible: boolean | undefined | null;
};

const Menu = styled.div`
  display: flex;
  align-items: center;
`;

// const ButtonWrapper = styled.div`
//   width: 156px;
//   height: 44px;
//   margin-left: auto;
//   margin-right: 20px;
// `;

export const MenuList = ({ isAdminMenuVisible = false }: MenuListProps) => {
  return (
    <Menu>
      {isAdminMenuVisible && (
        <>
          <MenuItem to={"/patient"}>
            <Typography bold size={2}>
              処方情報(SC)
            </Typography>
          </MenuItem>
          <MenuItem to={"/patient_ht"}>
            <Typography bold size={2}>
              処方情報(HT)
            </Typography>
          </MenuItem>
          <MenuItem to={"/patient_haudy"}>
            <Typography bold size={2}>
              処方情報(HAUDY)
            </Typography>
          </MenuItem>
        </>
      )}
      <MenuItem to={"/medicalInstitution"}>
        <Typography bold size={2}>
          医療機関情報
        </Typography>
      </MenuItem>
      {/* TODO: ファイルアップロード機能でアップロードファイルが空になる問題が解消されたら表示する */}
      {/* <MenuItem to={"/pdt"}>
        <Typography bold size={2}>
          アプリ情報
        </Typography>
      </MenuItem> */}
      {/* <MenuItem to={"/deliveryOrder"}>
        <Typography bold size={2}>
          物品情報
        </Typography>
      </MenuItem> */}
      {/* {isAdminMenuVisible && (
        <>
          <MenuItem to={"/member"}>
            <Typography bold size={2}>
              メンバー
            </Typography>
          </MenuItem>
          <MenuItem to={"/admin"}>
            <Typography bold size={2}>
              管理者メニュー
            </Typography>
          </MenuItem>
        </>
      )} */}
      {/* <ButtonWrapper>
        <RoundButton buttonType={"primary"} onClick={onCreatePrescriptionClick}>
          <Typography size={2} bold>
            新規処方
          </Typography>
        </RoundButton>
      </ButtonWrapper> */}
      {isAdminMenuVisible && (
        <MenuItem to={"/notifications"}>
          <Typography bold size={2}>
            お知らせ管理
          </Typography>
        </MenuItem>
      )}
    </Menu>
  );
};
